import React, { useState } from "react";
import { getGrpcClient, getUuidv4 } from "../config/Common.tsx";
import { ZiFetchRequest } from "../protobuf/generated/ZiFetchService_grpc_web_pb.js";
import GlobalMsgCons from "../config/GlobalMsgCons.tsx";

const ContactSection: React.FC = () => {
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    useCase: "",
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoader(true);
      let { name, email, company, useCase } = formData;
      let postJson = {
        reqId: getUuidv4(),
        name,
        email,
        companyName: company,
        useCaseDescription: useCase,
      };
      console.log("postJson", postJson);
      const request = new ZiFetchRequest();
      request.setDomain("silo");
      request.setEvent("contactUs");
      request.setMessage(JSON.stringify(postJson));
      request.setDatetime(new Date().toString());
      getGrpcClient().sayZiFetch(request, {}, (err: any, response: any) => {
        if (
          response === null ||
          response.getMessage() === GlobalMsgCons.invalidRequest
        ) {
          console.warn("Invalid Request. Please try again later");
        } else {
          let responseData = JSON.parse(response.getMessage());
          setLoader(false);
          if (responseData.response === GlobalMsgCons.success) {
            alert("Thank you for your message! We will get back to you soon.")
            setFormData({
              name: "",
              email: "",
              company: "",
              useCase: "",
            });
          }
        }
      });
    } catch (error) {
      alert(
        "Sorry, there was an error sending your message. Please try again later."
      );
    }
  };
  return (
    <section
      id="contact"
      style={{ background: "#223A5E", padding: "4rem 0", textAlign: "center" }}
    >
      <h2
        style={{
          color: "#fff",
          fontSize: "2.5rem",
          fontWeight: 800,
          marginBottom: "1rem",
        }}
      >
        Ready to Transform Medical Education?
      </h2>
      <p
        style={{
          color: "#d1d8f0",
          fontSize: "1.25rem",
          marginBottom: "3rem",
          maxWidth: "900px",
          margin: "0 auto 3rem auto",
        }}
      >
        Join leading medical schools and healthcare institutions already using
        SILO.
      </p>
      <form
        onSubmit={handleSubmit} 
        style={{
          maxWidth: 600,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "1.25rem",
          padding: "0 1rem",
        }}
      >
        <input
          required
          type="text"
          placeholder="Enter your name"
          style={{
            padding: "1rem",
            borderRadius: 4,
            fontFamily: 'inherit',
            border: "none",
            fontSize: "1.1rem",
          }}
          value={formData.name}
          onChange={(e) =>
            setFormData({ ...formData, name: e.target.value })
          }
        />
        <input
          required
          type="email"
          placeholder="Enter your email"
          style={{
            padding: "1rem",
            borderRadius: 4,
            fontFamily: 'inherit',
            border: "none",
            fontSize: "1.1rem",
          }}
          value={formData.email}
          onChange={(e) =>
            setFormData({ ...formData, email: e.target.value })
          }
        />
        <input
          required
          type="text"
          placeholder="Enter your company name"
          style={{
            padding: "1rem",
            borderRadius: 4,
            fontFamily: 'inherit',
            border: "none",
            fontSize: "1.1rem",
          }}
          value={formData.company}
          onChange={(e) =>
            setFormData({ ...formData, company: e.target.value })
          }
        />
        <textarea
          required
          placeholder="Describe your use case"
          rows={3}
          style={{
            padding: "1rem",
            borderRadius: 4,
            fontFamily: 'inherit',
            border: "none",
            fontSize: "1.1rem",
            resize: "vertical",
          }}
          value={formData.useCase}
          onChange={(e) =>
            setFormData({ ...formData, useCase: e.target.value })
          }
        />
        <button
          type="submit"
          style={{
            background: "#fff",
            color: "#223A5E",
            fontWeight: 700,
            fontSize: "1.15rem",
            border: "none",
            borderRadius: 4,
            padding: "1rem",
            marginTop: "0.5rem",
            cursor: "pointer",
          }}
          disabled={loader}
        >
          Contact Us
        </button>
      </form>
    </section>
  );
};

export default ContactSection;
